export const emptyString = "";
export const space = " ";
export const breakLineTag = "<br/>";
